module.exports = __webpack_public_path__ + "static/mask-5ffcc6c507eb0a15a308dad6a907ac0e.jpg";